export const ScreenSizeFloor = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
};

export enum ScreenSize {
  XS,
  SM,
  MD,
  LG,
  XL,
}
